module.exports = __webpack_public_path__ + "static/media/link_orange.189912ff.png";